export const getAvatarLettersFromName = (name?: string) => {
  return name ? name.match(/\b\w/g)?.slice(0, 2).join('').toUpperCase() : null;
};
